import { getStorageSync, setStorageSync } from "@modules/storage/storageHelper";
import { Routes } from "@utils/constants/routes";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useAppNavigate } from "./useAppNavigate";
import { useAppSelector } from "@lib/stores";
import { useAppLiveQuery } from "@modules/local/hooks";
import { db } from "@modules/local/db";
import { TabResponsibility } from "@wajeez/wajeez.microservices/dist/api.Server.clients";

export const useNavigateToHome = () => {
  const navigateRRD = useNavigate();

  const navigateToHome = useCallback(() => {
    const initUrl = getStorageSync("INIT_URL");
    console.log("initUrl", initUrl);

    navigateRRD((initUrl || "/") as keyof Routes);

    console.log("initUrl", initUrl);
    setStorageSync({
      key: "INIT_URL",
      data: "/",
    });
  }, [navigateRRD]);

  return navigateToHome;
};

export const useNavigateToTab = (tabResponsibility: TabResponsibility) => {
  const navigate = useAppNavigate();
  const userId = useAppSelector((state) => state.auth.user.id);
  const { result: flow } = useAppLiveQuery(
    () => db.readerFlows.get(userId ?? ""),
    [userId]
  );
  const navigateToTab = useCallback(() => {
    if (!flow || !flow.tabs) {
      return navigate("/");
    }

    const tab = flow.tabs.find(
      (t) => t.tabResponsibility === tabResponsibility
    );

    if (!tab) {
      return navigate("/");
    }

    return navigate("/", { tabId: tab.id });
  }, [navigate, flow, tabResponsibility]);

  return navigateToTab;
};
